<template>
  <div class="form-col">
    <div class="form-item">
      <label class="form-label">
        <span class="label-text">代付项列表：</span>
        <span class="label-tip">🤝</span>
      </label>
      <button @click="addProxy" class="btn btn-add">+ 添加代付项</button>
      <small class="field-hint">示例：A帮B垫付了部分费用</small>
      
      <div class="proxy-list">
        <div v-for="(item, index) in localProxyList" :key="index" class="proxy-item">
          <div class="input-group">
            <input 
              type="text" 
              v-model="item.proxyName" 
              placeholder="代付人姓名"
              class="form-input proxy-name"
              @input="handleProxyChange"
            >
            <small class="input-hint-small">谁垫付了钱</small>
          </div>
          <div class="input-group">
            <input 
              type="text" 
              v-model="item.beProxyName" 
              placeholder="被代付人姓名"
              class="form-input proxy-be-name"
              @input="handleProxyChange"
            >
            <small class="input-hint-small">谁应该付钱</small>
          </div>
          <div class="input-group">
            <input 
              type="number" 
              v-model.number="item.proxyAmount" 
              min="0" 
              placeholder="代付金额"
              class="form-input proxy-amount"
              @input="handleProxyChange"
            >
            <small class="input-hint-small">垫付的金额</small>
          </div>
          <button @click="deleteProxy(index)" class="btn btn-delete">删除</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProxyManager',
  props: {
    modelValue: {
      type: Array,
      default: () => [{ proxyName: '', beProxyName: '', proxyAmount: 0 }]
    }
  },
  data() {
    return {
      localProxyList: JSON.parse(JSON.stringify(this.modelValue))
    }
  },
  watch: {
    modelValue: {
      handler(newVal) {
        const newValStr = JSON.stringify(newVal)
        const localStr = JSON.stringify(this.localProxyList)
        if (newValStr !== localStr) {
          this.localProxyList = JSON.parse(newValStr)
        }
      },
      deep: true,
      immediate: true
    },
    localProxyList: {
      handler(newVal) {
        this.$emit('update:modelValue', JSON.parse(JSON.stringify(newVal)))
        this.$emit('change', JSON.parse(JSON.stringify(newVal)))
      },
      deep: true
    }
  },
  methods: {
    // 添加代付项
    addProxy() {
      this.localProxyList.push({ proxyName: '', beProxyName: '', proxyAmount: 0 })
    },

    // 删除代付项
    deleteProxy(index) {
      this.localProxyList.splice(index, 1)
    },

    // 代付项信息变化处理
    handleProxyChange() {
      this.$emit('update:modelValue', JSON.parse(JSON.stringify(this.localProxyList)))
      this.$emit('change', JSON.parse(JSON.stringify(this.localProxyList)))
    }
  }
}
</script>

<style scoped>
/* 表单列样式 */
.form-col {
  width: 100%;
}

/* 表单卡片样式 */
.form-item {
  margin-bottom: 0;
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: none;
}

.form-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

/* 表单标签样式 */
.form-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 12px;
  font-size: 14px;
}

.label-text {
  font-weight: 600;
  color: #4a5568;
}

.label-tip {
  font-size: 18px;
}

/* 按钮样式 */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
  margin-bottom: 12px;
}

.btn-add {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.btn-add:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}
/* 删除按钮 */
.btn-delete {
  background: linear-gradient(135deg, #f56565 0%, #e53e3e 100%);
  color: #fff;
  padding: 12px 16px;
  font-size: 13px;
  height: auto;
  margin-top: 0;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-delete:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(245, 101, 101, 0.4);
}

/* 字段提示 */
.field-hint {
  display: block;
  margin-bottom: 16px;
  font-size: 12px;
  color: #718096;
  font-style: italic;
  line-height: 1.4;
}

/* 代付项列表 */
.proxy-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* 代付项 */
.proxy-item {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.proxy-item:hover {
  background: #f1f5f9;
  border-color: #cbd5e0;
}

/* 输入组 */
.input-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* 输入框样式 */
.form-input {
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
  width: 100%;
  box-sizing: border-box;
  background: #fafafa;
  color: #2d3748;
}

.form-input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  background: #ffffff;
}

.form-input::placeholder {
  color: #a0aec0;
}

/* 输入框提示 */
.input-hint-small {
  font-size: 11px;
  color: #718096;
  font-style: italic;
  line-height: 1.3;
}

/* 响应式布局 */
@media (max-width: 750px) {
  .form-item {
    padding: 12px;
    border-radius: 8px;
  }
  
  .form-label {
    font-size: 13px;
    margin-bottom: 8px;
  }
  
  .btn {
    padding: 8px 12px;
    font-size: 13px;
  }
  
  /* 添加按钮 - 自适应宽度 */
  .btn-add {
    width: auto;
    margin-bottom: 10px;
  }
  
  /* 代付项 - 优化分栏布局 */
  .proxy-item {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
    gap: 8px;
    padding: 10px;
    align-items: flex-end;
  }
  
  /* 输入组样式 */
  .input-group {
    width: 100%;
    min-width: auto;
    margin: 0;
    grid-column: span 1;
  }
  
  /* 第三个输入组和删除按钮 - 第二行分栏 */
  .proxy-item > .input-group:nth-child(3) {
    grid-column: 1;
    grid-row: 2;
    width: 100%;
  }
  
  /* 删除按钮 - 与第三个输入组同一行，右侧对齐 */
  .btn-delete {
    grid-column: 2;
    grid-row: 2;
    width: auto;
    margin-left: 0;
    margin-top: 0;
    padding: 8px 16px;
    font-size: 12px;
    align-self: stretch;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .form-input {
    padding: 8px 12px;
    font-size: 13px;
    border-radius: 4px;
  }
  
  .field-hint {
    font-size: 11px;
    margin-bottom: 10px;
  }
  
  .input-hint-small {
    font-size: 10px;
  }
  
  /* 代付项列表间距缩小 */
  .proxy-list {
    gap: 12px;
  }
}

@media (max-width: 320px) {
  .form-item {
    padding: 14px;
  }
  
  .form-label {
    font-size: 12px;
  }
  
  .label-tip {
    font-size: 16px;
  }
  
  .btn {
    padding: 8px 12px;
    font-size: 12px;
  }
  
  .btn-delete {
    padding: 8px 12px;
    font-size: 12px;
    margin-top: 26px;
  }
  
  .proxy-item {
    padding: 10px;
  }
  
  .form-input {
    padding: 9px 12px;
    font-size: 13px;
  }
  
  .input-hint-small {
    font-size: 10px;
  }
}
</style>